{
  "Open support, new reply": "Abrir chat de soporte, nueva respuesta",
  "Open support": "Abrir chat de soporte",
  "Attachment": "Archivo adjunto",
  "Fin · previous AI assistant": "Fin · asistente de IA anterior",
  "EventLive support team": "Equipo de soporte de EventLive",
  "{name} · EventLive support": "{name} · Soporte de EventLive",
  "EventLive AI assistant": "Asistente de IA de EventLive",
  "Could not restore your previous conversation. You can retry by reopening the app.": "No se pudo recuperar tu conversación anterior. Para volver a intentarlo, abre de nuevo la app.",
  "Please choose a smaller image.": "Elige una imagen más pequeña.",
  "Please choose a JPEG or PNG image.": "Elige una imagen JPEG o PNG.",
  "Open {name}": "Abrir {name}",
  "We’re here to help": "Estamos aquí para ayudarte",
  "Team review requested · AI can still help": "Se avisó al equipo · La IA puede seguir ayudándote",
  "Collapse chat": "Contraer chat",
  "Expand chat": "Expandir chat",
  "Close support": "Cerrar chat de soporte",
  "Current conversation": "Conversación actual",
  "Hi! Ask me anything about EventLive: pricing, planning your livestream, or watching an event.": "¡Hola! Pregúntame lo que quieras sobre EventLive: precios, cómo planear tu transmisión en vivo o cómo ver un evento.",
  "Have an account? Sign in for help with your events": "¿Tienes una cuenta? Inicia sesión para recibir ayuda con tus eventos",
  "Ask anything about broadcasting, your events or pricing. I can use your account details and the screen you’re on to help.": "Pregunta lo que quieras sobre cómo transmitir, tus eventos o los precios. Para ayudarte, puedo usar los datos de tu cuenta y la pantalla en la que estás.",
  "Retry message": "Reintentar envío",
  "Remove photo": "Quitar foto",
  "Support message": "Mensaje para soporte",
  "Tell us what you’re trying to do…": "Cuéntanos qué intentas hacer…",
  "Attach": "Adjuntar",
  "Could not open your photos.": "No se pudieron abrir tus fotos.",
  "Send": "Enviar",
  "Close support backdrop": "Cerrar chat de soporte (fondo)",
  "AI assistant is typing": "El asistente de IA está escribiendo",
  "AI assistant": "Asistente de IA",
  "Please sign in to contact support.": "Inicia sesión para contactar con soporte.",
  "Could not reach support. Check your internet connection and try again.": "No se pudo conectar con soporte. Revisa tu conexión a internet e inténtalo de nuevo.",
  "Support is temporarily unavailable. Please try again.": "El soporte no está disponible por el momento. Inténtalo de nuevo.",
  "Could not send your message.": "No se pudo enviar tu mensaje.",
  "No message sent": "No se envió ningún mensaje",
  "Demo delivery: screenshot included · {platform}": "Envío de prueba: con captura de pantalla · {platform}",
  "Demo delivery: no screenshot · {platform}": "Envío de prueba: sin captura de pantalla · {platform}",
  "EventLive · Widget test": "EventLive · Prueba del widget",
  "Synthetic account and replies. No customer data or live API calls.": "Cuenta y respuestas ficticias. Sin datos de clientes ni llamadas a la API real.",
  "Your events": "Tus eventos",
  "Family celebration": "Celebración familiar",
  "Published · Recording ready": "Publicado · Grabación lista",
  "Demo delivery status": "Estado del envío de prueba",
  "{brand} support team": "Equipo de soporte de {brand}",
  "You’re chatting with the {brand} support team": "Estás chateando con el equipo de soporte de {brand}",
  "You’re talking with the {brand} AI assistant": "Estás hablando con el asistente de IA de {brand}",
  "The {brand} team is answering here. If you step away, they’ll also reply by email.": "El equipo de {brand} te está respondiendo aquí. Si te vas, también te responderá por correo.",
  "Hi! Ask me anything about YouthStream: plans and pricing, streaming your team’s games, or watching a game.": "¡Hola! Pregúntame lo que quieras sobre YouthStream: planes y precios, cómo transmitir los partidos de tu equipo o cómo ver un partido.",
  "Using the app? For help with your account, open Support Chat in YouthStream’s Profile.": "¿Usas la app? Para recibir ayuda con tu cuenta, abre el chat de soporte desde el perfil de YouthStream."
}
